var _ellipse, _path, _path2, _path3, _path4, _ellipse2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashOrMortgage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25,
    cy: 3.75,
    rx: 3.75,
    ry: 1.875,
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75C1.5 3.75 1.5 5.33947 1.5 6.375C1.5 7.41053 3.17893 8.25 5.25 8.25C7.32107 8.25 9 7.41053 9 6.375C9 5.76165 9 3.75 9 3.75",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.375C1.5 6.375 1.5 7.96447 1.5 9C1.5 10.0355 3.17893 10.875 5.25 10.875C7.32107 10.875 9 10.0355 9 9C9 8.38665 9 6.375 9 6.375",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 9 1.5 10.5895 1.5 11.625C1.5 12.6605 3.17893 13.5 5.25 13.5C7.32107 13.5 9 12.6605 9 11.625C9 11.0117 9 9 9 9",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.625C1.5 11.625 1.5 13.2145 1.5 14.25C1.5 15.2855 3.17893 16.125 5.25 16.125C7.32107 16.125 9 15.2855 9 14.25C9 13.6366 9 11.625 9 11.625",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.75,
    cy: 9,
    rx: 3.75,
    ry: 1.875,
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 9 9 10.5895 9 11.625C9 12.6605 10.6789 13.5 12.75 13.5C14.8211 13.5 16.5 12.6605 16.5 11.625C16.5 11.0117 16.5 9 16.5 9",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.625C9 11.625 9 13.2145 9 14.25C9 15.2855 10.6789 16.125 12.75 16.125C14.8211 16.125 16.5 15.2855 16.5 14.25C16.5 13.6366 16.5 11.625 16.5 11.625",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOrMortgage);
export default __webpack_public_path__ + "static/media/cashOrMortgage.9095460aad0d4ff4123d0668c520a3d4.svg";
export { ForwardRef as ReactComponent };